/**
 * Thin wrapper — delegates to the unified ImportEntriesModal with mode="results".
 * All results-import logic lives in ImportEntriesModal.tsx.
 */
import React from "react"
import ImportEntriesModal from "./ImportEntriesModal"

interface IImportResultsModalProps {
  visible: boolean
  setVisible: (newVisible: boolean) => void
  meetId: number
  refresh: () => void
}

export default function ImportResultsModal({
  visible,
  setVisible,
  meetId,
  refresh,
}: IImportResultsModalProps): JSX.Element {
  return (
    <ImportEntriesModal
      mode="results"
      visible={visible}
      setVisible={setVisible}
      meetId={meetId}
      refresh={refresh}
    />
  )
}
